angular.module('property-deal')
    .component('propertyDealPaymentSchedule', {
        bindings: {
            propertyDealId: '<',
            projectId: '<',
            totalPricing: '<',
            disabled: '<'
        },
        templateUrl: 'app/property-deal/payment-schedule-show.html',
        controller: function ($scope, modals, PropertyDeal, InvoiceService) {
            this.$onChanges = () => {
                this.propertyDealTotal = this.totalPricing.totalGross
                PropertyDeal.paymentSchedule({id: this.propertyDealId}).$promise.then(result => {
                    this.item = result
                    this.calculateTotal()

                }).catch(() => {
                    this.item = {
                        items: []
                    }
                    this.calculateTotal()
                })
            }

            this.edit = () => {
                let params = {
                    id: this.propertyDealId,
                    projectId: this.projectId,
                    total: this.propertyDealTotal
                };
                modals.open('app/property-deal/payment-schedule-edit.html', 'PropertyDealPaymentScheduleEditController', params, {size: "lg"}, "$ctrl").then(() => this.$onChanges())
            }

            this.calculateTotal = () => {
                let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
                this.scheduleTotal = {
                    amount: totalAmount
                }
                let totalLeftAmount = InvoiceService.sub(this.propertyDealTotal, totalAmount);
                this.scheduleTotalLeft = {
                    amount: totalLeftAmount
                }
            }
        }
    })
    .controller('PropertyDealPaymentScheduleEditController', function ($http, toastr, modals, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, InvoiceService) {
        this.$onInit = () => {
            this.projectId = data.projectId
            this.propertyDealTotal = data.total
            PropertyDeal.paymentSchedule({id: data.id}).$promise.then(result => {
                this.item = result
                this.calculateTotal()
            })
        }
        this.add = () => {
            this.item.items.push({})
        }
        this.addAmount = (amount) => {
            let item = this.item.items.find(item => item.amount == null);
            if(item == null) {
                item = {
                    amount: amount,
                }
                this.item.items.push(item)
            }
            else {
                item.amount = amount
            }
            this.onAmountChanged(item)
        }
        this.remove = ($index) => {
            this.item.items.splice($index, 1)
            this.calculateTotal()
        }
        this.onAmountChanged = (item) => {
            this.calculateTotal()
        }
        this.calculateTotal = () => {
            let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
            this.scheduleTotal = {
                amount: totalAmount
            }
            let totalLeftAmount = InvoiceService.sub(this.propertyDealTotal, totalAmount);
            this.scheduleTotalLeft = {
                amount: totalLeftAmount
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.delete = () => {
            return modals.confirmDelete("harmonogram", () => PropertyDeal.paymentScheduleDelete({id: data.id}).$promise.then(() => {
                $rootScope.$broadcast('property-deal.updated')
                $uibModalInstance.close()
            }))
        }
        this.save = () => {
            let form = {
                id: data.id,
                ...this.item
            }
            return PropertyDeal.paymentScheduleSave(form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                $uibModalInstance.close(result);
            })
        }
    })
